module.exports = __webpack_public_path__ + "static/merchants-17b5857ce44152aa958a828acd8820a3.png";